import React, { memo } from 'react';

// UI Components
import { GIButton } from 'app-components';

// Types & Config
import { IViewButtonProps } from '../planSummary.types';
import { configs } from '../../../../constants/configs/configs';

// Store / Hooks
import useAppSelector from '@hooks/useAppSelector';
import { environmentSelector } from '@selectors/commonSelectors';

// Styles
import { StyleViewBenefitContainer } from '../plansummary.styled';

const ViewBenefitButton = memo(({ coverageStartDate, planId }: IViewButtonProps) => {
    const { enablePlandisplayMS } = useAppSelector(environmentSelector);

    const getViewBenefitDetailsUrl = () => {
        const planInfoRoute = enablePlandisplayMS
            ? configs.routes.VIEW_PLAN_INFO_MS
            : configs.routes.VIEW_PLAN_INFO;

        return planInfoRoute
            .replace(':coverageStartDate', coverageStartDate.replace(/\//g, ''))
            .replace(':planId', planId);
    };

    return (
        <StyleViewBenefitContainer>
            <a
                data-testid="viewBenefitDetailsBtn"
                target="_blank"
                rel="noopener noreferrer"
                href={getViewBenefitDetailsUrl()}
            >
                <GIButton
                    id="view_benefit_details_btn"
                    data-testid="view-benefit-button"
                    labelId="plansummary.viewbenefitdetails"
                />
            </a>
        </StyleViewBenefitContainer>
    );
});

ViewBenefitButton.displayName = 'ViewBenefitButton';
export default ViewBenefitButton;
